import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FlaskConical, RotateCcw } from "lucide-react";
import { toast } from "sonner";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from "@/components/ui/alert-dialog";
import { api, errorMessage } from "@/lib/api";

export const ResetSampleButton = ({ workspace, className = "", label = "Reset sample" }) => {
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const reset = async () => {
    setBusy(true);
    try {
      await api.post(`/workspaces/${workspace.id}/sample/reset`);
      toast.success("Sample workspace reset");
      navigate(`/app/w/${workspace.id}`, { replace: true, state: { reset: Date.now() } });
      window.location.reload();
    } catch (e) {
      toast.error(errorMessage(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <AlertDialog>
      <AlertDialogTrigger data-testid="sample-workspace-reset-button" disabled={busy} className={`inline-flex items-center gap-1.5 ${className}`}>
        <RotateCcw className="h-3.5 w-3.5" /> {busy ? "Resetting..." : label}
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Reset the sample workspace?</AlertDialogTitle>
          <AlertDialogDescription>This puts the practice documents, actions and deadlines back the way they started. Your real homeowner or agent workspaces are not touched.</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="sample-reset-cancel-button">Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={reset} data-testid="sample-reset-confirm-button" className="bg-navy hover:bg-navy-2">Reset sample</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export const SampleBanner = ({ workspace }) => (
  <div data-testid="sample-workspace-banner" className="sticky top-[60px] lg:top-0 z-20 border-b border-gold/50 bg-gold-light">
    <div className="mx-auto flex max-w-6xl flex-col gap-2 px-4 py-3 sm:flex-row sm:items-center sm:justify-between sm:px-8">
      <p className="flex items-start gap-2 text-sm text-navy">
        <FlaskConical className="mt-0.5 h-4 w-4 shrink-0 text-gold-dark" />
        <span><strong className="font-semibold tracking-wide">SAMPLE WORKSPACE.</strong> Practice records only, not your real properties. Uploads, emails and reminders are turned off here.</span>
      </p>
      <ResetSampleButton workspace={workspace} className="self-start rounded-md border border-navy/20 bg-white px-3 py-1.5 text-xs font-medium text-navy hover:bg-navy hover:text-white transition-colors sm:self-auto" />
    </div>
  </div>
);
